import { render, staticRenderFns } from "./DialogAddDividends.vue?vue&type=template&id=798f9c0b"
import script from "./DialogAddDividends.vue?vue&type=script&lang=js"
export * from "./DialogAddDividends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports